import PlaylistItem from './view';

export default PlaylistItem;
